import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { useInvAF, useInvMain } from "../../../../St/Reviews/UseStyle";
function FooterD4(porps) {

    const { found, inv, sta } = porps;
    const locDinv = JSON.parse(localStorage.getItem("datainv")) || {};
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

    const clas = useInvAF();
    const sty = {
        cntr: { textAlign: "center", paddingTop: 10 },
        lft: { textAlign: "left", padingLeft: 5 },
        rit: { textAlign: "right", padingRight: 5 },
        dirR: {
            direction: "rtl",
            color: "black",
        },
        dirL: { direction: "ltr" },
    };
    return (
        <Grid item container style={sty.dirR}>
            <Grid item container style={sty.cntr} spacing={0}>
            </Grid>
            <Grid
                item
                container
                xs={12}
                spacing={1}
                style={{ paddingTop: 10, fontWeight: "bold", textAlign: "center" }}
            >
                <Grid item xs={12} style={{ fontFamily: "Amiri-Regular" }}>
                    <Grid item xs={12} container className={clas.footerA}>
                        <Grid item xs={12} className={clas.BdytotCntMmm}>
                            {found.BillNotes}
                        </Grid>
                        <br />

                    </Grid>

                </Grid>

            </Grid>
        </Grid>
    );
}
export default FooterD4;

